export default {
    path: 'voucher',
    component: () => import('../Voucher.vue'),
    children: [
        {
            path: '',
            name: 'Danh sách Mã giảm',
            component: () => import('../table/Table.vue')
        },
        {
            path: 'cu',
            name: 'Tạo Mã giảm',
            component: () => import('../cu/CU.vue')
        },
        {
            path: 'cu/:id',
            name: 'Chỉnh sửa Mã giảm',
            component: () => import('../cu/CU.vue')
        },
    ]
};